//@flow
import React from "react";
import { Table, Column, Cell } from "fixed-data-table-2";
import {
  getFormattedCell,
  getSectionData,
  isInputColumn,
  formatInputColumn
} from "./LineItemTableCellHelpers";
import Dimensions from "react-dimensions";
import "fixed-data-table-2/dist/fixed-data-table.css";
import LineItemTableSubSectionHeader from "./LineItemSubSectionHeader/LineItemTableSubSectionHeader";
import s from "./LineItemTableCell.less";
import _ from "lodash";

type Props = {
  section: string,
  tableTitle: string,
  data: Array<Object>,
  containerWidth: number,
  totalFob: number,
  totalCost: number,
  sortBy: string,
  columns: Array<Object>
};

type State = {
  frozen: Array<string>
};

class LineItemTableSubSection extends React.Component<Props, State> {
  state = {
    frozen: ["LOGIC GROUP"],
    columnWidths: {},
    data: this.props.data
  };

  async shouldComponentUpdate(prevProps) {
    if (this.props.sortBy !== prevProps.sortBy) {
      this.setState({
        data: this.state.data.sort(
          (a, b) => Number(a[prevProps.sortBy]) - Number(b[prevProps.sortBy])
        )
      });
    }
  }

  _freezeColumn = columnKey => {
    if (this.state.frozen.includes(columnKey)) {
      this.setState({
        frozen: this.state.frozen.filter(e => e !== columnKey)
      });
    } else {
      this.setState({
        frozen: [...this.state.frozen, columnKey]
      });
    }
  };

  _onColumnResizeEndCallback = (newColumnWidth, columnKey) => {
    this.setState(({ columnWidths }) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newColumnWidth
      }
    }));
  };

  render() {
    const data = this.state.data;
    if (!data[0]) return null;
    const columns = _.omit(data[0], ["sortingNumberInt", "pccSortOrder"]);

    const sectionData = getSectionData(
      data,
      this.props.tableTitle,
      this.props.totalCost,
      this.props.isNby
    );
    const capitalizedSectionTitle =
      this.props.section.charAt(0).toUpperCase() + this.props.section.slice(1);
    const defaultColWidth = 110;
    return (
      <div>
        <LineItemTableSubSectionHeader
          totalCost={this.props.totalCost}
          sectionData={sectionData}
          section={capitalizedSectionTitle}
          tableTitle={this.props.tableTitle}
        />
        <Table
          rowHeight={50}
          rowsCount={data.length}
          width={this.props.containerWidth}
          maxHeight={600}
          headerHeight={70}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          isColumnResizing={false}
        >
          {Object.keys(columns).map(columnKey => (
            <Column
              fixed={this.state.frozen.includes(columnKey) ? true : false}
              key={columnKey}
              columnKey={columnKey}
              isResizable={true}
              header={
                isInputColumn(columnKey) ? (
                  formatInputColumn(columnKey, this._freezeColumn)
                ) : (
                  <Cell className={`${s.headerCell}`} onClick={() => this._freezeColumn(columnKey)}>
                    {columnKey}
                  </Cell>
                )
              }
              cell={({ rowIndex, columnKey }) =>
                getFormattedCell(
                  data,
                  rowIndex,
                  columnKey,
                  capitalizedSectionTitle,
                  this.props.tableTitle
                )
              }
              width={
                this.state.columnWidths[columnKey]
                  ? this.state.columnWidths[columnKey]
                  : defaultColWidth
              }
            />
          ))}
        </Table>
      </div>
    );
  }
}

export default Dimensions()(LineItemTableSubSection);



// WEBPACK FOOTER //
// ./src/components/CBDTables/LineItemTables/LineItemTablesContainer/LineItemTableSubSection/LineItemTableSubSection.js